export function hasText(obj: object, text: string, caseInsensitive: boolean = false) {
	const lc = caseInsensitive ? text.toLowerCase() : text;
	const vals = allValues(obj);
	const matches = vals.filter((i) => (caseInsensitive ? i.toLowerCase() : i).indexOf(lc) > -1);
	return matches.length > 0;
}

export function allValues(obj: object) {
	const valsOut: string[] = Object.entries(obj)
		.map<string | string[]>((i) => {
			const type = typeof i[1];

			if (!i[1]) return "";

			switch (type) {
				case "function":
					return "";
				case "object":
					const vals = allValues(i[1]);
					return vals;
				case "boolean":
				case "undefined":
					return "";
				default:
					return `${i[1]}`.trim();
			}
		})
		.flat(1)
		.filter((i) => !!i);
	return valsOut;
}
